const EMAIL_PREVIEW_CANVAS_PADDING_CSS = `
  body {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
    box-sizing: border-box;
  }
`;

const EMAIL_PREVIEW_CANVAS_PADDING_STYLE_TAG = `<style data-email-preview-canvas-padding>${EMAIL_PREVIEW_CANVAS_PADDING_CSS}</style>`;

export function withEmailPreviewCanvasPadding(html: string): string {
  if (!html.trim()) {
    return html;
  }

  if (html.includes("data-email-preview-canvas-padding")) {
    return html;
  }

  if (html.includes("</head>")) {
    return html.replace("</head>", `${EMAIL_PREVIEW_CANVAS_PADDING_STYLE_TAG}</head>`);
  }

  return `${EMAIL_PREVIEW_CANVAS_PADDING_STYLE_TAG}${html}`;
}
